// @ts-nocheck

import withApollo from 'next-with-apollo';
import {
	ApolloClient,
	InMemoryCache,
	ApolloProvider,
	NormalizedCacheObject,
	createHttpLink,
} from '@apollo/client';
import { getSession } from '../helpers/index';
import { setContext } from 'apollo-link-context';

export default withApollo(
	({ initialState }) => {
		const httpLink = createHttpLink({
			uri: process.env.API_URL,
		});

		const authLink = setContext((_, { headers }) => {
			const token = getSession();
			return {
				headers: {
					...headers,
					authorization: token ? `Bearer ${token}` : null,
				},
			};
		});

		return new ApolloClient<NormalizedCacheObject>({
			uri: process.env.API_URL,
			cache: new InMemoryCache(),
			link: authLink.concat(httpLink),
			name: 'react-web-client',
			version: '1.3',
			queryDeduplication: false,
			defaultOptions: {
				watchQuery: {
					nextFetchPolicy: 'network-only',
				},
			},
		});
	},
	{
		render: ({ Page, props }) => {
			if (process.env.NODE_ENV === 'test') {
				return <Page />;
			}

			return (
				<ApolloProvider client={props.apollo}>
					<Page />
				</ApolloProvider>
			);
		},
	},
);
